import { PropsWithChildren } from 'react';

import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';
import merge from 'lodash/merge';

import { theme, ThemePaletteCssVars, tokens } from '@cast/design-system';
import { useIsDarkMode } from '@cast/shared-theme-data-access';

const oneClickTheme = createTheme(
  merge({}, theme, {
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: tokens.theme.bg.structural.page,
            color: tokens.theme.fg.structural.primary,
          },
        },
      },
    },
  })
);

export const ThemeProvider = ({ children }: PropsWithChildren<unknown>) => {
  // Subscribe so jotai-effect keeps data-theme in sync for the full app lifetime.
  useIsDarkMode();

  return (
    <MuiThemeProvider theme={oneClickTheme}>
      <ThemePaletteCssVars />
      {children}
    </MuiThemeProvider>
  );
};
